export function sortRows(rows, sort) {
  if (!sort.key) return rows;
  const sorted = [...rows].sort((a, b) => {
    const av = a[sort.key];
    const bv = b[sort.key];
    if (av === null || av === undefined) return 1;
    if (bv === null || bv === undefined) return -1;
    if (typeof av === 'string') return av.localeCompare(bv, undefined, { numeric: true });
    return av - bv;
  });
  return sort.dir === 'desc' ? sorted.reverse() : sorted;
}

export function SortableTh({ label, sortKey, sort, onSort, align = 'left' }) {
  const active = sort.key === sortKey;
  return (
    <th
      className={`px-4 py-2 text-sm font-medium text-gray-500 cursor-pointer select-none hover:text-gray-700 ${align === 'right' ? 'text-right' : 'text-left'}`}
      onClick={() => onSort(sortKey)}
    >
      {label} {active ? (sort.dir === 'asc' ? '▲' : '▼') : ''}
    </th>
  );
}

export function toggleSort(setSort, key) {
  setSort(prev => prev.key === key ? { key, dir: prev.dir === 'asc' ? 'desc' : 'asc' } : { key, dir: 'asc' });
}
